/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('MyGamesToken' in value) || value['MyGamesToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestFromJSON(json) {
    return FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'] == null ? undefined : json['GameSystemName'],
        'Game': json['Game'] == null ? undefined : json['Game'],
        'Token': json['Token'],
        'MyGamesToken': json['MyGamesToken'],
    };
}
export function FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSON(json) {
    return FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'Game': value['Game'],
        'Token': value['Token'],
        'MyGamesToken': value['MyGamesToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest.js.map